export * from './authentication';
export * from './orders';
export * from './reservations';
export * from './shifts';
export * from './customers';
export * from './tables';
export * from './marketing';
export * from './settings';
export * from './ui';
export * from './autoRefresh';
export * from './zones';
export * from './artefacts';
export * from './feedbacks';



// WEBPACK FOOTER //
// ./src/store/actions/index.js